import { ArticleDto } from '@core/mappers/news/dtos/ArticleDto';

export const ArticleStatus = {
    active: 'active',
    inactive: 'inactive',
};
export type ArticleStatus = typeof ArticleStatus[keyof typeof ArticleStatus];

export const ArticleBodySegmentType = {
    RawHtml: 'RawHtml',
    MatchOfferWidget: 'MatchOfferWidget',
    MarketOfferWidget: 'MarketOfferWidget',
    SuperBetsWidget: 'SuperBetsWidget',
} as const;
export type ArticleBodySegmentType = typeof ArticleBodySegmentType[keyof typeof ArticleBodySegmentType];

export type Article = ArticlePreview & {
    body: BodySegment[];
    seo: ArticleDto['seo'];
    thumbnailImage?: string;
    fullImage?: string;
    category: string;
};

export type ArticlePreview = {
    id: string;
    title: string;
    subtitle: string;
    slug: string;
    datePublished: Date;
    datePublishedUntil?: Date;
    image?: string;
    status: ArticleStatus;
    // The next two are needed for linking them up to stats screens
    matchId?: number;
    superbetMatchIds?: number[];
    tournamentId?: number;
    // Experimental social testing articles. For the time being, won't be shown in article lists
    socialUserId?: string;
};

export type BodySegment =
    | RawHtmlSegment
    | MatchOfferWidget
    | MarketOfferWidget
    | SuperBetsWidget;

export type RawHtmlSegment = {
    type: typeof ArticleBodySegmentType.RawHtml;
    content: RawHtml;
    customClassName?: string;
};

type MatchOfferWidget = {
    type: typeof ArticleBodySegmentType.MatchOfferWidget;
    matchId: number;
};

type MarketOfferWidget = {
    type: typeof ArticleBodySegmentType.MarketOfferWidget;
    matchId: number;
    marketId: number;
};

type SuperBetsWidget = {
    type: typeof ArticleBodySegmentType.SuperBetsWidget;
    matchId: number;
};

type RawHtml = string;
